import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsPortalModule } from '@cmps/ng-uikit';

import {
    LineAreaChartEventCalloutDirective,
    LineAreaChartGoalCalloutDirective,
    LineAreaComponent,
} from '../coaching-insight/line-area.component';

@NgModule({
    imports: [CommonModule, CmpsPortalModule],
    declarations: [
        LineAreaComponent,
        LineAreaChartEventCalloutDirective,
        LineAreaChartGoalCalloutDirective,
    ],
    exports: [
        LineAreaComponent,
        LineAreaChartEventCalloutDirective,
        LineAreaChartGoalCalloutDirective,
    ],
})
export class CmpsChartModule {}
